import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAppDispatch } from 'shared/hooks'

import type { Conversation } from '../model/types'

import { api } from '../api'
import { getConversationUrl } from '../utils/utils'
import { useCurrentId } from './useCurrentId'

export function useSelectFirstChat(conversations?: Conversation[]) {
	const conversation = useCurrentId()
	const dispatch = useAppDispatch()
	const { push } = useHistory()

	useEffect(() => {
		if (!conversation) {
			if (conversations?.length) {
				const { entity_id: id, participants } = conversations[0]
				dispatch(api.util.upsertQueryData('participants', id, participants))
				push(getConversationUrl(id))
			}
		}
	}, [push, conversation, conversations, dispatch])
}
